import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useQuery from '@/hooks/useQuery';
import { ReviewsQuery } from '@/queries/reviews.gql';
import { BReviewOrderEnum } from '@/types/backend';
import { getAfterFromPageIndex } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useState } from 'react';
import { REVIEWS_PER_PAGE } from './reviews.const';
import ReviewsContext from './reviews.context';
export const ReviewsProvider = (t0) => {
    const $ = _c(58);
    const { children, entity } = t0;
    const [showTranslated, setShowTranslated] = useState(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = () => {
            setShowTranslated(_temp);
        };
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const toggleShowTranslated = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const [aggregatedExperiences, setAggregatedExperiences] = useState(t2);
    const hasExperienceFilter = aggregatedExperiences.length > 1;
    let t3;
    if ($[2] !== aggregatedExperiences) {
        t3 = Object.fromEntries(aggregatedExperiences.map(_temp2));
        $[2] = aggregatedExperiences;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const [experienceOptions, setExperienceOptions] = useState(t3);
    let t4;
    let t5;
    if ($[4] !== aggregatedExperiences) {
        t4 = () => {
            setExperienceOptions(Object.fromEntries(aggregatedExperiences.map(_temp3)));
        };
        t5 = [aggregatedExperiences];
        $[4] = aggregatedExperiences;
        $[5] = t4;
        $[6] = t5;
    }
    else {
        t4 = $[5];
        t5 = $[6];
    }
    useEffect(t4, t5);
    let t6;
    if ($[7] !== experienceOptions) {
        t6 = Object.entries(experienceOptions).filter(_temp4).map(_temp5);
        $[7] = experienceOptions;
        $[8] = t6;
    }
    else {
        t6 = $[8];
    }
    const selectedExperienceIds = t6;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [];
        $[9] = t7;
    }
    else {
        t7 = $[9];
    }
    const [aggregatedOccasions, setAggregatedOccasions] = useState(t7);
    const hasOccasionFilter = aggregatedOccasions.length > 1;
    let t8;
    if ($[10] !== aggregatedOccasions) {
        t8 = Object.fromEntries(aggregatedOccasions.map(_temp6));
        $[10] = aggregatedOccasions;
        $[11] = t8;
    }
    else {
        t8 = $[11];
    }
    const [occasionOptions, setOccasionOptions] = useState(t8);
    let t10;
    let t9;
    if ($[12] !== aggregatedOccasions) {
        t9 = () => {
            setOccasionOptions(Object.fromEntries(aggregatedOccasions.map(_temp7)));
        };
        t10 = [aggregatedOccasions];
        $[12] = aggregatedOccasions;
        $[13] = t10;
        $[14] = t9;
    }
    else {
        t10 = $[13];
        t9 = $[14];
    }
    useEffect(t9, t10);
    let t11;
    if ($[15] !== occasionOptions) {
        t11 = Object.entries(occasionOptions).filter(_temp8).map(_temp9);
        $[15] = occasionOptions;
        $[16] = t11;
    }
    else {
        t11 = $[16];
    }
    const selectedOccasions = t11;
    const [order, setOrder] = useState(BReviewOrderEnum.CreatedDesc);
    const [activePageIndex, setActivePageIndex] = useState(0);
    let t12;
    if ($[17] !== activePageIndex) {
        t12 = getAfterFromPageIndex(activePageIndex, REVIEWS_PER_PAGE);
        $[17] = activePageIndex;
        $[18] = t12;
    }
    else {
        t12 = $[18];
    }
    const after = t12;
    let t13;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = () => {
            setActivePageIndex(0);
        };
        $[19] = t13;
    }
    else {
        t13 = $[19];
    }
    let t14;
    if ($[20] !== order || $[21] !== selectedExperienceIds || $[22] !== selectedOccasions) {
        t14 = [selectedOccasions, selectedExperienceIds, order];
        $[20] = order;
        $[21] = selectedExperienceIds;
        $[22] = selectedOccasions;
        $[23] = t14;
    }
    else {
        t14 = $[23];
    }
    useEffect(t13, t14);
    let t15;
    if ($[24] !== aggregatedExperiences.length || $[25] !== aggregatedOccasions.length) {
        t15 = (data) => {
            const reviews = data.reviews;
            if (reviews) {
                if (!aggregatedOccasions.length && reviews.aggregations?.occasion) {
                    setAggregatedOccasions(reviews.aggregations.occasion);
                }
                if (!aggregatedExperiences.length && reviews.aggregations?.bookable) {
                    setAggregatedExperiences(reviews.aggregations.bookable);
                }
            }
        };
        $[24] = aggregatedExperiences.length;
        $[25] = aggregatedOccasions.length;
        $[26] = t15;
    }
    else {
        t15 = $[26];
    }
    const handleQueryCompletion = t15;
    const t16 = selectedOccasions.length ? selectedOccasions : null;
    let t17;
    if ($[27] !== after || $[28] !== entity.identifier || $[29] !== order || $[30] !== t16) {
        t17 = { first: REVIEWS_PER_PAGE, after, locale: LOCALE, bookableId: entity.identifier, order, occasion: t16 };
        $[27] = after;
        $[28] = entity.identifier;
        $[29] = order;
        $[30] = t16;
        $[31] = t17;
    }
    else {
        t17 = $[31];
    }
    let t18;
    if ($[32] !== handleQueryCompletion || $[33] !== t17) {
        t18 = { variables: t17, onCompleted: handleQueryCompletion, fetchPolicy: "cache-and-network" };
        $[32] = handleQueryCompletion;
        $[33] = t17;
        $[34] = t18;
    }
    else {
        t18 = $[34];
    }
    const { data: reviewsQueryData, loading: reviewsQueryLoading } = useQuery(ReviewsQuery, t18);
    const queryResults = reviewsQueryData?.reviews || null;
    const totalCount = queryResults?.totalCount || null;
    let t19;
    if ($[35] !== queryResults?.edges) {
        t19 = queryResults?.edges ?
            (queryResults?.edges).map(_temp0).filter(_temp1) : [];
        $[35] = queryResults?.edges;
        $[36] = t19;
    }
    else {
        t19 = $[36];
    }
    const reviews_0 = t19;
    const [hasResults, setHasResults] = useState(false);
    let t20;
    let t21;
    if ($[37] !== totalCount) {
        t20 = () => {
            setHasResults((c_0) => c_0 ? c_0 : totalCount > 0);
        };
        t21 = [totalCount];
        $[37] = totalCount;
        $[38] = t20;
        $[39] = t21;
    }
    else {
        t20 = $[38];
        t21 = $[39];
    }
    useEffect(t20, t21);
    const loadingReviews = reviewsQueryLoading;
    let t22;
    if ($[40] !== activePageIndex || $[41] !== entity || $[42] !== experienceOptions || $[43] !== hasExperienceFilter || $[44] !== hasOccasionFilter || $[45] !== hasResults || $[46] !== loadingReviews || $[47] !== occasionOptions || $[48] !== order || $[49] !== reviews_0 || $[50] !== selectedExperienceIds || $[51] !== selectedOccasions || $[52] !== showTranslated || $[53] !== totalCount) {
        t22 = { entity, reviews: reviews_0, loadingReviews, hasResults, showTranslated, toggleShowTranslated, totalCount, activePageIndex, setActivePageIndex, order, setOrder, hasOccasionFilter, selectedOccasions, occasionOptions, setOccasionOptions, hasExperienceFilter, selectedExperienceIds, experienceOptions, setExperienceOptions };
        $[40] = activePageIndex;
        $[41] = entity;
        $[42] = experienceOptions;
        $[43] = hasExperienceFilter;
        $[44] = hasOccasionFilter;
        $[45] = hasResults;
        $[46] = loadingReviews;
        $[47] = occasionOptions;
        $[48] = order;
        $[49] = reviews_0;
        $[50] = selectedExperienceIds;
        $[51] = selectedOccasions;
        $[52] = showTranslated;
        $[53] = totalCount;
        $[54] = t22;
    }
    else {
        t22 = $[54];
    }
    const contextValue = t22;
    let t23;
    if ($[55] !== children || $[56] !== contextValue) {
        t23 = <ReviewsContext value={contextValue}>{children}</ReviewsContext>;
        $[55] = children;
        $[56] = contextValue;
        $[57] = t23;
    }
    else {
        t23 = $[57];
    }
    return t23;
};
function _temp(c) { return !c; }
function _temp2(bookable) { return [bookable.identifier, { bookable, checked: false }]; }
function _temp3(bookable_0) { return [bookable_0.identifier, { bookable: bookable_0, checked: false }]; }
function _temp4(t0) { const [, t1] = t0; const { checked } = t1; return !!checked; }
function _temp5(t0) { const [, t1] = t0; const { bookable: t2 } = t1; const { identifier } = t2; return identifier; }
function _temp6(key) { return [key, false]; }
function _temp7(key_0) { return [key_0, false]; }
function _temp8(t0) { const [, value] = t0; return !!value; }
function _temp9(t0) { const [key_1] = t0; return key_1; }
function _temp0(t0) { const { node } = t0; return node; }
function _temp1(node_0) { return !!node_0; }
